import { Link } from "react-router-dom";
import { Squiggle, Star } from "./Illustrations";
import { Heart, Flower, Spiral } from "./Doodles";
import Reveal from "./Reveal";

export default function OurStory() {
  return (
    <section className="relative py-24 md:py-36 px-5 md:px-10 overflow-hidden" data-testid="our-story">
      <Flower size={42} className="absolute top-16 right-[8%] wiggle hidden md:block" color="#F4C734" center="#DD2E20" />
      <Spiral size={50} className="absolute bottom-24 left-[6%] hidden md:block" color="#8BC547" />
      <Heart size={32} className="absolute top-1/3 right-[3%] wiggle hidden lg:block" />

      <div className="relative mx-auto max-w-[1280px] grid md:grid-cols-12 gap-10 md:gap-16 items-center">
        {/* Story image stack */}
        <div className="md:col-span-5 relative">
          <Reveal>
            <div className="aspect-[4/5] rounded-[28px] overflow-hidden bg-[#F3EADA] lift" data-hover="true">
              <img
                src="/founder/founder-1.jpeg"
                alt="Natasha, the founder of SOL Kids, with her daughter wearing SOL Kids sunglasses"
                className="w-full h-full object-cover"
                loading="lazy"
                data-testid="founder-hero-image"
              />
            </div>
            <p className="mt-3 text-xs uppercase tracking-[0.18em] text-[#8C8C86] font-medium">The founder &amp; her muse</p>
          </Reveal>
          <Reveal delay={120}>
            <div className="absolute -bottom-2 -right-4 md:-right-10 w-[52%] aspect-[4/5] rounded-2xl overflow-hidden shadow-[0_24px_48px_rgba(0,0,0,0.14)] hidden md:block border-4 border-[#FAFAF7]">
              <img
                src="/founder/founder-2.jpeg"
                alt="Natasha holding her daughter — a quiet moment at home"
                className="w-full h-full object-cover"
                loading="lazy"
                data-testid="founder-inset-image"
              />
            </div>
          </Reveal>
          <Star size={28} className="absolute -top-4 -left-2 wiggle" color="#F2D06B" />
        </div>

        {/* Story copy */}
        <div className="md:col-span-7 md:pl-8">
          <Reveal>
            <p className="eyebrow mb-5">Our story</p>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[1.05] tracking-[-0.025em]">
              Started with a<br />
              mother's <span className="italic" style={{ color: "#DD2E20" }}>instinct.</span>
            </h2>
          </Reveal>
          <Reveal delay={160}>
            <Squiggle w={120} className="my-7 opacity-60" />
          </Reveal>
          <Reveal delay={200}>
            <div className="space-y-5 text-[#2C2C2A] text-lg md:text-xl leading-relaxed max-w-[58ch]">
              <p>To protect what matters most.</p>
              <p>When I learned how the sun affects little eyes, I knew I wanted better. <span className="font-medium">Safer. Stronger. Smarter.</span></p>
              <p>Every child wears the world a little differently. Some run. Some lead. Some dream. Some explore.</p>
              <p className="font-hand text-3xl md:text-4xl text-[#2C2C2A]/90 pt-4">Love &amp; sun-light, Natasha</p>
            </div>
          </Reveal>
          <Reveal delay={300}>
            <div className="mt-8">
              <Link to="/story" className="inline-flex items-center gap-2 text-[15px] font-medium ink-link" data-testid="story-read-more">
                Read the full story →
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
